import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Toaster } from 'ngx-toast-notifications';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class MunicipalPoliceGuard implements CanActivate {
  constructor(
    public authService: AuthService,
    public router: Router,
    public toaster: Toaster) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    let isNotMunicipalityPolice = JSON.parse(localStorage.getItem('currentUser'))['role'] !== 'municipality_police'

    if (localStorage.getItem('currentUser') && localStorage.getItem('currentUser') !== null && isNotMunicipalityPolice) {
      // logged in so return true
      return true;
    }

    this.toaster.open({
      caption: 'Access Denied',
      text: 'You cannot view this page',
      type: 'warning'
    })
    this.router.navigate(['/home/dashboard']);

    return false;
  }

}
